import { mount } from 'svelte';
import Admin from './Admin.svelte';
// The same design system and base as the till, the dashboard and the website.
import '../design.css';
import '../base.css';

const target = document.getElementById('app');
if (!target) {
	throw new Error('the mount point #app is missing from admin/index.html');
}

export default mount(Admin, { target });
